export default [{"url":"https://shopify-0.api.invexerp.io","name":"Branch 1","port":"6535","isStore":true,"isHQ":true}]